/**
 * 分析列表统计卡片组件
 */
import React from 'react';
import { Row, Col } from 'antd';
import { TeamOutlined, CheckCircleOutlined, ClockCircleOutlined, RiseOutlined } from '@ant-design/icons';
import { StatsCard } from '../../../components/UI/Card/StatsCard';

interface AnalysisStatsProps {
    stats: { total: number; hasData: number; noData: number; thisMonth: number };
    loading: boolean;
}

export const AnalysisStats: React.FC<AnalysisStatsProps> = ({ stats, loading }) => {
    return (
        <Row gutter={[24, 24]} style={{ marginBottom: 32 }}>
            <Col xs={24} sm={12} lg={6}>
                <StatsCard
                    title="总SKU数"
                    value={stats.total}
                    icon={<TeamOutlined />}
                    color="blue"
                    loading={loading}
                />
            </Col>
            <Col xs={24} sm={12} lg={6}>
                <StatsCard
                    title="已有数据"
                    value={stats.hasData}
                    icon={<CheckCircleOutlined />}
                    color="green"
                    loading={loading}
                    trend={
                        stats.hasData > 0
                            ? {
                                value: Math.round((stats.hasData / stats.total) * 100),
                                type: 'increase',
                                label: '占比',
                                suffix: '%',
                            }
                            : undefined
                    }
                />
            </Col>
            <Col xs={24} sm={12} lg={6}>
                <StatsCard
                    title="待上传数据"
                    value={stats.noData}
                    icon={<ClockCircleOutlined />}
                    color="orange"
                    loading={loading}
                />
            </Col>
            <Col xs={24} sm={12} lg={6}>
                <StatsCard
                    title="本月新增"
                    value={stats.thisMonth}
                    icon={<RiseOutlined />}
                    color="purple"
                    loading={loading}
                />
            </Col>
        </Row>
    );
};
